// extracted by mini-css-extract-plugin
export default {"actions":"Actions_actions__CW7hn","action":"Actions_action__RJBf0","button":"Actions_button__2-JIa","icon":"Actions_icon__E0yW7"};